import styled from 'styled-components';

import { Tooltip } from 'src/components/tooltip';

export const TextContainer = styled.div`
  flex: 1 0 0;
  line-height: var(--dcm-login-nudge-line-height);
  font: var(--dcm-login-nudge-font-size) var(--dcm-login-nudge-font-family);
  color: var(--dcm-login-nudge-text-color);
`;

export const LoginLink = styled.span`
  cursor: pointer;
  color: var(--dcm-login-nudge-link-color);
`;
export const SocialLoginContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--dcm-login-nudge-gap);
  align-self: stretch;
`;

export const SocialButtonContainer = styled.button`
  display: flex;
  width: var(--dcm-login-nudge-social-btn-size);
  height: var(--dcm-login-nudge-social-btn-size);
  padding: 0;
  justify-content: center;
  align-items: center;
  border-radius: var(--dcm-login-nudge-social-btn-radius);
  border: none;
  cursor: pointer;
  background: var(--dcm-login-nudge-social-btn-bg);

  svg {
    width: var(--dcm-login-nudge-social-icon-size);
    height: var(--dcm-login-nudge-social-icon-size);
    flex-shrink: 0;
  }
`;

export const CloseButton = styled.button`
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledTooltip = styled(Tooltip)`
  && {
    background: var(--dcm-login-nudge-bg);
    box-shadow: var(--dcm-login-nudge-shadow);
  }
  &&::before {
    background: var(--dcm-login-nudge-bg);
  }
  button svg path {
    fill: var(--dcm-login-nudge-close-color);
  }
`;
